<template>
  <div class="attendance-main">
    <el-tabs v-model="tabActive"
             type="card">
      <el-tab-pane label="考勤设置"
                   name="1"></el-tab-pane>
      <el-tab-pane label="考勤记录"
                   name="2"></el-tab-pane>
    </el-tabs>
    <settings v-if="tabActive === '1'"
              :tab="tabActive"></settings>
    <records v-if="tabActive === '2'"
             :tab="tabActive"></records>
  </div>
</template>
<script>
import Settings from '@/views/business/attendance/Settings'
import Records from '@/views/business/attendance/Records'
export default {
  components: { Settings, Records },
  data() {
    return {
      tabActive: '1'
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="less">
.attendance-main {
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: #fff;
    border-bottom-color: #409eff;
  }
}
</style>